import CityPageTemplate from "../city-template/CityPageTemplate";
import { kodiakConfig } from "./data";

export default function KodiakPage() {
  return <CityPageTemplate config={kodiakConfig} />;
}